import {
  UPDATE_LOGS_REQUEST,
  UPDATE_LOGS_SUCCESS,
  UPDATE_LOGS_FAILURE,
  GET_LOGS_REQUEST,
  GET_LOGS_FAILURE,
  GET_LOGS_SUCCESS,
} from "./actionTypes";

import { Log } from "../../core/entities/log";

export const updateLog = (applicantId: string, logs: Log) => ({
  type: UPDATE_LOGS_REQUEST,
  payload: { applicantId, logs },
});

export const updateLogSuccess = () => ({
  type: UPDATE_LOGS_SUCCESS,
});

export const updateLogFailure = (error: string) => ({
  type: UPDATE_LOGS_FAILURE,
  payload: { error },
});

export const getLogs = (applicantId: string) => ({
  type: GET_LOGS_REQUEST,
  payload: { applicantId },
});

export const getLogsSuccess = (logs: { logs: Log[]; id: string }) => ({
  type: GET_LOGS_SUCCESS,
  payload: { logs },
});

export const getLogsFailure = (error: string) => ({
  type: GET_LOGS_FAILURE,
  payload: { error },
});
